module.exports = __webpack_public_path__ + "assets/ic_weather02.5d313753.svg";